export const ESTATUS_CONFIG = {
    N: { label: "No iniciado", dot: "#8d9688", bg: "#eef0ec", text: "#4f5a4b", border: "#d5d9d0" },
    S: { label: "Cargado", dot: "#0891b2", bg: "#e0f7fa", text: "#065f70", border: "#67d4e8" },
    I: { label: "Por iniciar", dot: "#7c3aed", bg: "#f3effe", text: "#4c1d95", border: "#c4b5fd" },
    P: { label: "En proceso", dot: "#639922", bg: "#eaf3de", text: "#27500a", border: "#97c459" },
    R: { label: "En revisión", dot: "#d97706", bg: "#fff8e1", text: "#7c4a00", border: "#fbbf24" }, // ámbar — revisión
    V: { label: "Vencido", dot: "#e24b4a", bg: "#fcebeb", text: "#791f1f", border: "#f09595" },
    F: { label: "Finalizado", dot: "#378add", bg: "#e8f0fa", text: "#0c447c", border: "#85b7eb" },
    C: { label: "Cancelado", dot: "#ba7517", bg: "#faeeda", text: "#633806", border: "#ef9f27" },
    A: { label: "Autorizado", dot: "#7f77dd", bg: "#eeedfe", text: "#3c3489", border: "#afa9ec" },
};